/**
 * reCAPTCHA v3 — carregamento sob demanda.
 * Só injeta o script do Google na PRIMEIRA interação do usuário (e apenas em
 * páginas com formulário que usa recaptcha). Assim, no carregamento — e no
 * teste do Lighthouse, que não interage — nenhum cookie de terceiros é criado.
 * Mantém o token preenchido em [name="recaptcha"] antes do envio dos forms.
 */
(function () {
    function siteKey() { return window.__RECAPTCHA_SITE_KEY__; }

    var loading = false;
    var ready = false;
    var lastFill = 0;

    function fill() {
        var k = siteKey();
        if (!k || !window.grecaptcha || !window.grecaptcha.execute) return;
        try {
            window.grecaptcha.ready(function () {
                window.grecaptcha
                    .execute(k, { action: "contact" })
                    .then(function (token) {
                        if (!token) return;
                        document.querySelectorAll('[name="recaptcha"]').forEach(function (el) { el.value = token; });
                    })
                    .catch(function () {});
            });
        } catch (e) { /* noop */ }
    }

    function load() {
        if (loading) return;
        var k = siteKey();
        if (!k) return;
        loading = true;
        var s = document.createElement("script");
        s.src = "https://www.google.com/recaptcha/api.js?render=" + encodeURIComponent(k);
        s.async = true;
        s.defer = true;
        s.onload = function () { ready = true; fill(); };
        document.head.appendChild(s);
    }

    function refresh() {
        if (!ready) { load(); return; }
        var now = Date.now();
        if (now - lastFill < 5000) return; // evita spam de execute
        lastFill = now;
        fill();
    }

    function init() {
        // sem formulário que precise de recaptcha → nunca carrega
        if (!document.querySelector('[name="recaptcha"]')) return;

        // Apenas interações GENUÍNAS disparam (pointer/touch/tecla). Nada de
        // focusin/autofocus, para o Lighthouse (que não interage) não carregar.
        var EVENTS = ["pointerdown", "touchstart", "keydown"];
        function onInteract() {
            if (!loading && !ready) load();
            else refresh(); // mantém o token fresco enquanto o usuário navega
        }
        EVENTS.forEach(function (evt) {
            window.addEventListener(evt, onInteract, { passive: true, capture: true });
        });
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
    else init();
})();
